<script>
import WootDropdownItem from 'shared/components/ui/dropdown/DropdownItem.vue';
import WootDropdownMenu from 'shared/components/ui/dropdown/DropdownMenu.vue';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';

export default {
  components: {
    WootDropdownItem,
    WootDropdownMenu,
    Thumbnail,
  },

  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    hasThumbnail: {
      type: Boolean,
      default: true,
    },
    // Sem default cravado em ingles. `'Search'` e `'No results found'` estavam
    // escritos aqui, e todo consumidor que omitisse a prop -- o seletor de
    // participantes da conversa, por exemplo -- exibia essas palavras em ingles
    // independentemente do idioma da conta. Prop default no Vue 2 nao alcanca o
    // `$t` (nao ha `this`), entao o vazio entra como sentinela e a traducao vem
    // do computed logo abaixo. Quem passa a prop continua mandando no texto.
    inputPlaceholder: {
      type: String,
      default: '',
    },
    noSearchResult: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      search: '',
    };
  },

  computed: {
    placeholderDaBusca() {
      return (
        this.inputPlaceholder || this.$t('GENERAL.MULTISELECT_DROPDOWN.SEARCH')
      );
    },
    textoSemResultado() {
      return (
        this.noSearchResult ||
        this.$t('GENERAL.MULTISELECT_DROPDOWN.NO_RESULTS')
      );
    },
    filteredOptions() {
      return this.options.filter(option => {
        return option.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    noResult() {
      return this.filteredOptions.length === 0 && this.search !== '';
    },
  },

  mounted() {
    this.focusInput();
  },

  methods: {
    onclick(option) {
      this.$emit('click', option);
    },
    focusInput() {
      this.$refs.searchbar.focus();
    },
    isActive(option) {
      return this.selectedItems.some(item => item && option.id === item.id);
    },
  },
};
</script>

<template>
  <div class="dropdown-wrap">
    <div class="mb-2 flex-shrink-0 flex-grow-0 flex-auto max-h-8">
      <input
        ref="searchbar"
        v-model="search"
        type="text"
        class="search-input"
        autofocus="true"
        :placeholder="placeholderDaBusca"
      />
    </div>
    <div class="flex justify-start items-start flex-auto overflow-auto">
      <div class="w-full max-h-[10rem]">
        <WootDropdownMenu>
          <WootDropdownItem v-for="option in filteredOptions" :key="option.id">
            <woot-button
              class="multiselect-dropdown--item"
              :variant="isActive(option) ? 'hollow' : 'clear'"
              color-scheme="secondary"
              :class="{
                active: isActive(option),
              }"
              @click="() => onclick(option)"
            >
              <div class="flex items-center gap-1.5">
                <Thumbnail
                  v-if="hasThumbnail"
                  :src="option.thumbnail"
                  size="24px"
                  :username="option.name"
                  :status="option.availability_status"
                  has-border
                />
                <div
                  class="flex items-center justify-between w-full min-w-0 gap-2"
                >
                  <span
                    class="leading-4 my-0 overflow-hidden whitespace-nowrap text-ellipsis text-sm"
                    :title="option.name"
                  >
                    {{ option.name }}
                  </span>
                  <fluent-icon v-if="isActive(option)" icon="checkmark" />
                </div>
              </div>
            </woot-button>
          </WootDropdownItem>
        </WootDropdownMenu>
        <h4
          v-if="noResult"
          class="w-full justify-center items-center flex text-subtle py-2 px-2.5 overflow-hidden whitespace-nowrap text-ellipsis text-sm"
        >
          {{ textoSemResultado }}
        </h4>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropdown-wrap {
  @apply w-full flex flex-col max-h-[12.5rem];
}

.search-input {
  @apply m-0 w-full border border-solid border-transparent h-8 text-sm text-muted rounded-md bg-surface-raised focus:border-primary-400 focus:ring-1 focus:ring-primary-400 dark:focus:border-primary-500 dark:focus:ring-primary-500 transition-shadow duration-200 outline-none;
}

.multiselect-dropdown--item {
  @apply justify-between w-full;

  &.active {
    @apply bg-surface-raised border-line-faint font-medium ring-1 ring-primary-400/50;
  }

  &:focus {
    @apply bg-surface-raised;
  }

  &:hover {
    @apply bg-surface-raised text-body;
  }
}
</style>
